import { t } from '@lingui/macro';
import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import { toast } from 'react-hot-toast';
import useSWRMutation from 'swr/mutation';
import { type ParamsSchemaT, sendFormation } from '../utils/send-formation';

export function useSendFormation() {
  const { client } = useApi();

  return useSWRMutation(
    'send-quark-formation',
    (key, { arg }: SWRArgs<ParamsSchemaT>) => {
      return toast.promise(sendFormation(client, arg), {
        loading: arg.id
          ? t`Mise à jour de la formation ${arg.name}.`
          : t`Création de la formation ${arg.name}.`,
        success: arg.id
          ? t`La formation ${arg.name} a bien été mise à jour.`
          : t`La formation ${arg.name} a bien été créée.`,
        error: arg.id
          ? t`Une erreur est survenue lors de la mise à jour de la formation.`
          : t`Une erreur est survenue lors de la création de la formation.`,
      });
    }
  );
}
